export const slide_to = 'slideto';
export const slide_from = 'slidefrom';
export const slide_down = 'slidedown';
export const slide_up = 'slideup';
export const slide_in = 'slidein';
export const slide_out = 'slideout';
export const push_down = 'pushdown';
export const push_up = 'pushup';
export const collection = 'collection';
export const properties = 'properties';

export const arc = 'arc';
export const linear = 'linear';
export const vertical_rotation = 'vertical_rotation';
export const horizontal_rotation = 'horizontal_rotation';
export const vertical_rotation_z = 'vertical_rotation_z';
export const horizontal_rotation_z = 'horizontal_rotation_z';



// WEBPACK FOOTER //
// ./src/helpers/animation_types.js